import React, { useState, useEffect, useRef } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Popover from "../../common/components/popover/popover.js";
import { projects as getProjects } from '../../common/api/projects';
import ProjectsList from "../Projects/ProjectsList";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';
import logoGrey from '../../common/media/cc_logo_grey.svg';

const LandingPage = ({ merchantCode, fetchedImpact, oneOfConfig }) => {
    const [projects, setProjects] = useState();

    const [num, setNum]= useState(0);
    const incNum =()=>{
        if(num<1000)
        {
        setNum(Number(num)+1);
        }
    };
    const decNum = () => {
        if(num>0)
        {
        setNum(num - 1);
        }
    }
    const handleChange = (e)=>{
    setNum(e.target.value);
    }
    
    
    let numberOfContributions = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    let carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    let carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase();
    let treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    
    if(numberOfContributions == ""){
        numberOfContributions = 0;
    }
    if(carbonOffsetImpact == "NaN"){
        carbonOffsetImpact = 0;
    }
    if(treeGrowthYears == ""){
        treeGrowthYears = 0;
    }
    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${treeGrowthYears} trees have in one year.`;
    
        
    useEffect(() => {
        getProjects(null, merchantCode).then(response => response.json()).then(data => setProjects(data)).catch(setProjects);

    }, []);

    return (
        <div>
            <header className="headerSection">
                <div className="container">
                    <div className="logo-box">
                        <a href="javascript:void(0);"><img style={{height: 40}} src="https://res.cloudinary.com/carbonclick/image/upload/v1651490743/Enterprise/Vegan%20Supply/vegan-supply-logo_jxnazx.svg" /></a>
                    </div>
                </div>
            </header>
            <div className="heroSection">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-md">
                            <div className="heroContent">
                                <h1>Climate friendly choices have never been easier</h1>
                                <p>Vegan Supply is here to help you reduce your environmental <br/>impacts even further!</p>
                                <a href="#shopClimateFriendly" className="btn btn-primary">Learn more</a>
                            </div>
                        </div>
                        <div className="col-md-auto">
                            <div className="d-flex align-items-center pwdBy mb-3">
                                <p className="my-0 mr-3">Powered by</p>
                                <img src={logoGrey} style={{ height: 24 }} alt="Powered by carbonclick" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="climatefrndSec" id="shopClimateFriendly">
                <div className="container-cus mx-auto">
                    <div className="secHead text-center">
                        <h2>Shop Climate Friendly</h2>
                        <p>The Climate Friendly Cart is a tool we use to help mitigate climate change and lower the environmental impact of online shopping. The programme supports high quality climate projects that make a real traceable difference. <br /><b>Together we are fighting climate change.</b></p>
                        <p>Simply click the Green Button at checkout to contribute $2 to our carefully selected carbon offsetting projects that fight climate change.</p>
                    </div>
                    <div className="secForm">
                        <img src="https://res.cloudinary.com/carbonclick/image/upload/v1657911548/Enterprise/Vegan%20Supply/green-cart-form_ur1l59.svg" />
                    </div>
                </div>
            </div>
           
            <div className="climateSection">
                <div className="container-cus mx-auto">
                    <h2 className="text-black">Customer Carbon Impact</h2>
                    <div className="row mobile-hide">
                        <div className="col-sm-4">
                            <div className="climateBoxes">
                                <div className="d-flex img-bx">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1651490744/Enterprise/Vegan%20Supply/image--304_2_pwlmgm.png" alt="Image" />
                                </div>
                                <div className="climateText">
                                    <h3>{numberOfContributions}</h3>
                                    <p>People offsetting their <br/>vegan shopping</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="climateBoxes">
                                <div className="d-flex img-bx">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1651490743/Enterprise/Vegan%20Supply/image_66_oks9ym.png" alt="Image" />
                                </div>
                                <div className="climateText">
                                    <h3>{carbonOffsetImpact}</h3>
                                    <p><span className="text-cap">{carbonOffsetImpactUnit}</span> of carbon offset</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="climateBoxes">
                                <div className="d-flex img-bx">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1651490743/Enterprise/Vegan%20Supply/image_65_knhv50.png" alt="Image" />
                                </div>
                                <div className="climateText">
                                    <h3>{treeGrowthYears}</h3>
                                    <p>
                                        <span className="mr-2">Trees</span>
                                        <Popover content={treeMetric}>
                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="7.5" cy="7.5" r="7.5" fill="#C62B2A"/><path d="M6.73633 9.52319C6.51183 9.52319 6.32983 9.3412 6.32983 9.1167V9.1167C6.32983 8.76514 6.40491 8.45935 6.55505 8.19934C6.7052 7.93933 6.97986 7.66284 7.37903 7.36987C7.76355 7.09521 8.01624 6.87183 8.13708 6.69971C8.2616 6.52759 8.32385 6.33533 8.32385 6.12292C8.32385 5.88489 8.23596 5.70361 8.06018 5.5791C7.8844 5.45459 7.63904 5.39233 7.3241 5.39233C6.94497 5.39233 6.52921 5.47781 6.07682 5.64876C5.7205 5.78342 5.30692 5.65237 5.13719 5.31136V5.31136C4.97449 4.98446 5.09537 4.58249 5.43244 4.44209C6.0744 4.17471 6.74523 4.04102 7.44495 4.04102C8.19934 4.04102 8.7981 4.22229 9.24121 4.58484C9.68799 4.94739 9.91138 5.43079 9.91138 6.03503C9.91138 6.43787 9.81982 6.78577 9.63672 7.07874C9.45361 7.3717 9.10571 7.70129 8.59302 8.0675C8.24146 8.32751 8.01807 8.52527 7.92285 8.66077C7.8313 8.79626 7.78552 8.97388 7.78552 9.1936V9.1936C7.78552 9.37563 7.63796 9.52319 7.45593 9.52319H6.73633ZM6.15405 11.4019C6.15405 11.0942 6.23645 10.8617 6.40125 10.7042C6.56604 10.5468 6.80591 10.468 7.12085 10.468C7.4248 10.468 7.65918 10.5486 7.82397 10.7097C7.99243 10.8708 8.07666 11.1016 8.07666 11.4019C8.07666 11.6912 7.99243 11.92 7.82397 12.0885C7.65552 12.2533 7.42114 12.3357 7.12085 12.3357C6.81323 12.3357 6.5752 12.2551 6.40674 12.094C6.23828 11.9292 6.15405 11.6985 6.15405 11.4019Z" fill="white"/></svg>
                                        </Popover>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show mt-4 text-center">
                        <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true} >
                            <div key="1">
                                <div className="climateBoxes">
                                    <div className="d-flex img-bx">
                                        <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1651490744/Enterprise/Vegan%20Supply/image--304_2_pwlmgm.png" alt="Image" />
                                    </div>
                                    <div className="climateText">
                                        <h3>{numberOfContributions}</h3>
                                        <p>People offsetting their <br/>vegan shopping</p>
                                    </div>
                                </div>
                            </div>

                            <div key="2">
                                <div className="climateBoxes">
                                    <div className="d-flex img-bx">
                                        <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1651490743/Enterprise/Vegan%20Supply/image_66_oks9ym.png" alt="Image" />
                                    </div>
                                    <div className="climateText">
                                        <h3>{carbonOffsetImpact}</h3>
                                        <p>{carbonOffsetImpactUnit} of carbon offset</p>
                                    </div>
                                </div>
                            </div>

                            <div key="3">
                                <div className="climateBoxes">
                                    <div className="d-flex img-bx">
                                        <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1651490743/Enterprise/Vegan%20Supply/image_65_knhv50.png" alt="Image" />
                                    </div>
                                    <div className="climateText">
                                        <h3>{treeGrowthYears}</h3>
                                        <p>
                                            <span className="mr-2">Trees</span>
                                            <Popover content={treeMetric}>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="7.5" cy="7.5" r="7.5" fill="#C62B2A"/><path d="M6.73633 9.52319C6.51183 9.52319 6.32983 9.3412 6.32983 9.1167V9.1167C6.32983 8.76514 6.40491 8.45935 6.55505 8.19934C6.7052 7.93933 6.97986 7.66284 7.37903 7.36987C7.76355 7.09521 8.01624 6.87183 8.13708 6.69971C8.2616 6.52759 8.32385 6.33533 8.32385 6.12292C8.32385 5.88489 8.23596 5.70361 8.06018 5.5791C7.8844 5.45459 7.63904 5.39233 7.3241 5.39233C6.94497 5.39233 6.52921 5.47781 6.07682 5.64876C5.7205 5.78342 5.30692 5.65237 5.13719 5.31136V5.31136C4.97449 4.98446 5.09537 4.58249 5.43244 4.44209C6.0744 4.17471 6.74523 4.04102 7.44495 4.04102C8.19934 4.04102 8.7981 4.22229 9.24121 4.58484C9.68799 4.94739 9.91138 5.43079 9.91138 6.03503C9.91138 6.43787 9.81982 6.78577 9.63672 7.07874C9.45361 7.3717 9.10571 7.70129 8.59302 8.0675C8.24146 8.32751 8.01807 8.52527 7.92285 8.66077C7.8313 8.79626 7.78552 8.97388 7.78552 9.1936V9.1936C7.78552 9.37563 7.63796 9.52319 7.45593 9.52319H6.73633ZM6.15405 11.4019C6.15405 11.0942 6.23645 10.8617 6.40125 10.7042C6.56604 10.5468 6.80591 10.468 7.12085 10.468C7.4248 10.468 7.65918 10.5486 7.82397 10.7097C7.99243 10.8708 8.07666 11.1016 8.07666 11.4019C8.07666 11.6912 7.99243 11.92 7.82397 12.0885C7.65552 12.2533 7.42114 12.3357 7.12085 12.3357C6.81323 12.3357 6.5752 12.2551 6.40674 12.094C6.23828 11.9292 6.15405 11.6985 6.15405 11.4019Z" fill="white"/></svg>
                                            </Popover>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>

            <div className="investmentSec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 d-lg-none">
                            <img src="https://res.cloudinary.com/carbonclick/image/upload/v1651490745/Enterprise/Vegan%20Supply/vegan-easy_jnvwcm.png" alt="" />
                        </div>
                        <div className="col-md-6 ml-auto">
                            <div className="max-485 ml-auto">
                                <h2 className="mt-0 text-white">We Make Vegan Easy </h2>
                                <p className="text-white">Food choices are one of the biggest contributors to our individual carbon footprint. Adopting a Vegan lifestyle is directly linked to lowering greenhouse gas emissions, reducing energy consumption, conserving water and relieving ecological burden across the Planet. Choosing a Vegan lifestyle reduces harm on Earth's precious resources, on our ocean’s ecosystems, and on the clearing of forests and land. Our association with CarbonClick allows you to offset your personal carbon footprint - please look into the projects that are funded through your donations to learn more about how your offsets improve the world we live in.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {Array.isArray(projects) &&
            <div className="projects projects-sec text-center">
                <div className="container-cus mx-auto">
                    <div className="secHead">
                        <h2 className="mt-0">Supporting Projects <br/>That Fight Climate Change</h2>
                        <p>Your contributions support only the highest quality climate projects, to bring you peace of mind <br/>and real impact in slowing climate change.</p>
                    </div>
                    <ProjectsList title={null} projects={projects} />
                </div>
            </div>
            }

            <div className="faq-sec">
                <div className="container-cus mx-auto">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="text-center">Climate Friendly FAQs</h2>
                            <div className="mb-3 center text-align-start">
                                <Accordian title={"Who is CarbonClick?"} >
                                    CarbonClick is a New Zealand technology company that exists to reverse climate change. By making carbon offseting simple, trustworthy and cost effective,  we empower businesses and their customers with the tools to start tackling their carbon emissions. 
                                </Accordian>
                                <Accordian title={"What does carbon offsetting do?"}>
                                    <span className='mb-2 d-block'>CarbonClick follows industry best practice to ensure that the offsets provided have a real, measurable impact on mitigating climate change.</span>
                                    Projects are scrutinised against their independently verified selection methodology, which uses many of the same stringent requirements of ICROA Code of Best Practice, such as true additionality, ensuring credible baseline reporting and verifying project developers integrity. Only projects that have considerable co-benefits are considered, 
                                    such as improving biodiversity, creating sustainable jobs, empowering women and minorities and improving community health and wellbeing.
                                </Accordian>
                                <Accordian title={"What are carbon credits?"} >
                                    A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.
                                </Accordian>
                                <Accordian title={"Where does the money go?"} >
                                    The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.
                                </Accordian>
                                <div className="text-center btn-utr"><a href={footerLinks.faq} className="btn btn-primary">Learn More</a></div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div className="w-100 footer-img" >
                <div className="container">
                    <div className="footerImg text-brown">
                        <div className="footer-width">
                            <p className="footer-powered text-white mt-0">POWERED BY</p>
                            <div className="row align-items-center">
                                <div className='col-md-auto col-6 width-50'>
                                    <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                        <img style={{ height: 24 }} className="footer-logo" src={logo} />
                                    </a>
                                </div>
                                <div className="col-md-6 ml-auto width-50">
                                    <div className="text-md-right">
                                        <p className="m-0 text-white">Log in to <a className="redtxt" href={footerLinks?.carbonclick} target="_blank">My CarbonClick</a> to see the impact</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="footer-hr"/>
                            <div className="row links bottom-links">
                                <div className="col-sm">
                                    <div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div>
                                        <div className="mb-25"><a className="medium" href={footerLinks?.contactUs} target="_blank" rel="noopener noreferrer">Contact us</a></div>
                                        <div className="mb-25"><a className="medium" href="mailto:hello+vegansupply@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                                    </div>
                                </div>
                            </div>  
                        </div>  
                    </div>

                </div>
            </div>
        </div>
    )
}


export default LandingPage;